'use client';

import DefaultAvatar from '@web-catalog/public/img/defaultAvatar.svg';
import VkIdLogo from '@web-catalog/public/img/logo_vkid-black.svg';
import Image from 'next/image';
import {useCallback, useState} from 'react';

import {useOmicronClientFlag} from '@web-catalog/hooks/omicron';

import {useAuthorizedProfile} from '@web-catalog/store/auth';

import {useAuthAnalytics} from '@web-catalog/utils/analytics/useAuthAnalytics';

import styles from './AuthHeaderComponent.module.scss';

export const AuthHeaderComponent = () => {
  const webAvailableAutoLoginType = useOmicronClientFlag('WEB_AUTO_LOGIN');
  const userInfo = useAuthorizedProfile();
  const {logAuthorizationHeaderClick} = useAuthAnalytics();

  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const handleShowTooltip = useCallback(() => {
    logAuthorizationHeaderClick();
    setIsTooltipVisible(true);
  }, [logAuthorizationHeaderClick]);

  const handleHideTooltip = useCallback(() => {
    setIsTooltipVisible(false);
  }, []);

  if (webAvailableAutoLoginType !== 'headerAvatar') {
    return;
  }

  return (
    <div className={styles.container} data-testid="auth-header-comp">
      {userInfo?.photo_200 && userInfo?.id && (
        <Image
          className={styles.avatar}
          src={userInfo?.photo_200 ?? <DefaultAvatar />}
          alt={userInfo?.first_name ?? 'User avatar'}
          width={40}
          height={40}
          onMouseOver={handleShowTooltip}
          onMouseOut={handleHideTooltip}
        />
      )}
      {!userInfo?.photo_200 && userInfo?.id && (
        <DefaultAvatar
          onMouseOver={handleShowTooltip}
          onMouseOut={handleHideTooltip}
        />
      )}
      {isTooltipVisible && (
        <div className={styles.tooltip}>
          <div className={styles.name}>
            {userInfo?.first_name ?? userInfo?.id}
          </div>
          <div className={styles.id}>
            Вы вошли с помощью <VkIdLogo />
          </div>
        </div>
      )}
    </div>
  );
};
